import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import { FastField, Formik } from 'formik';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useMemo, useRef, useState } from 'react';

DialogAddChargeModelView.propTypes = {
  item: PropTypes.object,
  chargeBrandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAddChargeModelView({ item, chargeBrandId, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const editMode = !!item;
  const [imageSrc, setImageSrc] = useState(null);
  const refFormik = useRef(null);
  const initialFormikValues = useMemo(() => {
    return {
      brandId: chargeBrandId,
      name: item?.name || '',
      description: item?.description || '',
      image: item?.image || '',
      type: item?.type || ChargeConstants.ChargePointType.AC,
      // connectors: item?.connectors || 1,
      // connectorType: item?.connectorType || '',
      power: item?.power ? item?.power / 1000 : 0,
      voltage: item?.voltage || 0,
      protocol: item?.protocol || 'OCPP 1.6',
      vehicleType: item?.vehicleType || ChargeConstants.VehicleType.CAR,
      price: item?.price || 0,
    };
  }, [item, chargeBrandId]);
  const [loading, setLoading] = useState(false);

  // MARK: ---- METHODS ----
  const handleSubmit = async (values) => {
    let param = { ...values };
    delete param.image;
    if (imageSrc) {
      const res = await miscHelper.callApiUploadFile(imageSrc);
      if (_.isArray(res) && res.length > 0) {
        param.image = res[0].relativePath;
      }
    }
    if (param.power) {
      param.power = _.isString(param.power)
        ? _.toNumber(param?.power?.replace(',', '.')) * 1000
        : param.power * 1000;
    }
    // param = _.omitBy(param, _.isNil);
    // console.log({ param });
    // return;
    setLoading(true);
    try {
      if (!editMode) {
        const response = await ChargeHelper.API.requestAddChargeModel(param);
        if (_.isBoolean(response) && response) {
          ToastHelper.showSuccess('Thêm dòng trụ sạc thành công');
          if (onDone) {
            onDone();
          }
        } else if (_.isString(response)) {
          ToastHelper.showError(response);
        }
      } else {
        const response = await ChargeHelper.API.requestUpdateChargeModel(item?.modelId, param);
        if (_.isBoolean(response) && response) {
          ToastHelper.showSuccess('Cập nhật dòng trụ sạc thành công');
          if (onDone) {
            onDone();
          }
        } else if (_.isString(response)) {
          ToastHelper.showError(response);
        }
      }
    } catch (error) { }
    setLoading(false);
  };

  return (
    <div>
      <Formik
        initialValues={initialFormikValues}
        enableReinitialize
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={ChargeHelper.ValidationSchema.chargeModel}
      >
        {(formikProps) => {
          refFormik.current = formikProps;
          return (
            <div className="d-flex flex-column">
              <div className="row m-0 p-0 px-3 mt-4">
                <div className="col-12 mb-4 px-2">
                  <div className="w-120px">
                    {UIHelper.buildFormLabel('Ảnh dòng trụ sạc', true)}
                    <FastField name="image">
                      {({ field, form, meta }) => (
                        <KTImageInput
                          fullWidth={true}
                          aspectRatio={'1'}
                          name={field.name}
                          editable={true}
                          value={Utils.getFullUrl(field.value)}
                          acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                          defaultImage={
                            AppResource.images.chargeConnectorTypes.imgChargePointDefault
                          }
                          enableCheckValid
                          onSelectedFile={(file) => {
                            setImageSrc(file);
                            const imageUrl = URL.createObjectURL(file);
                            form.setFieldValue(field.name, imageUrl);
                          }}
                          onRemovedFile={() => {
                            setImageSrc(null);
                            form.setFieldValue(field.name, '');
                          }}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                        />
                      )}
                    </FastField>
                  </div>
                  {UIHelper.buildFormText('Định dạng: JPG, PNG')}
                </div>
              </div>
              <div className="row m-0 p-0 px-3">
                <div className="col-6 p-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildFormLabel('Tên dòng trụ sạc', true)}
                    <FastField name="name">
                      {({ field, form, meta }) => (
                        <KTFormInput
                          type={KTFormInputType.text}
                          placeholder="Nhập tên dòng trụ sạc"
                          name={field.name}
                          value={field.value}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          onBlur={() => {
                            form.setFieldTouched(field.name, true);
                          }}
                          enableCheckValid={true}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
                <div className="col-6 p-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildFormLabel('Loại phương tiện', true)}
                    <FastField name="vehicleType">
                      {({ field, form, meta }) => (
                        <KTBSDropdown
                          name={field.name}
                          toggleElement={
                            <button
                              className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                              type="button"
                            >
                              {field.value
                                ? _.find(
                                  ChargeHelper.Data.vehicleTypeOptions,
                                  (item) => item?.value === field.value
                                )?.name
                                : 'Chọn loại phương tiện'}
                            </button>
                          }
                          selectedValue={field.value}
                          dropdownMenuItems={ChargeHelper.Data.vehicleTypeOptions}
                          dropdownMenuClassName="overflow-auto w-100"
                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          isDropdownForm={true}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
                <div className="col-6 p-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildFormLabel('Loại trụ sạc', true)}
                    <FastField name="type">
                      {({ field, form, meta }) => (
                        <KTBSDropdown
                          name={field.name}
                          toggleElement={
                            <button
                              className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                              type="button"
                            >
                              {field.value
                                ? _.find(
                                  ChargeHelper.Data.chargePointTypeOptions,
                                  (item) => item?.value === field.value
                                )?.name
                                : 'Chọn loại trụ sạc'}
                            </button>
                          }
                          selectedValue={field.value}
                          dropdownMenuItems={ChargeHelper.Data.chargePointTypeOptions}
                          dropdownMenuClassName="overflow-auto w-100"
                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          isDropdownForm={true}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
                <div className="col-6 p-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildFormLabel('Giao thức', true)}
                    <FastField name="protocol">
                      {({ field, form, meta }) => (
                        <KTFormInput
                          type={KTFormInputType.text}
                          placeholder="Nhập giao thức"
                          name={field.name}
                          value={field.value}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          onBlur={() => {
                            form.setFieldTouched(field.name, true);
                          }}
                          enableCheckValid={true}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                          disabled={true}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
                <div className="col-6 p-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildFormLabel('Công suất', true)}
                    <FastField name="power">
                      {({ field, form, meta }) => (
                        <KTFormInput
                          type={KTFormInputType.currency}
                          unit="kW"
                          placeholder="Nhập công suất"
                          name={field.name}
                          value={field.value ?? ''}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value ?? '');
                          }}
                          onBlur={() => {
                            form.setFieldTouched(field.name, true);
                          }}
                          enableCheckValid={true}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
                <div className="col-6 p-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildFormLabel('Điện áp', true)}
                    <FastField name="voltage">
                      {({ field, form, meta }) => (
                        <KTFormInput
                          type={KTFormInputType.currency}
                          unit="V"
                          placeholder="Nhập điện áp"
                          name={field.name}
                          value={field.value ?? ''}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value ?? '');
                          }}
                          onBlur={() => {
                            form.setFieldTouched(field.name, true);
                          }}
                          enableCheckValid={true}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
                <div className="col-6 p-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildFormLabel('Đơn giá', true)}
                    <FastField name="price">
                      {({ field, form, meta }) => (
                        <KTFormInput
                          type={KTFormInputType.currency}
                          unit="VNĐ"
                          placeholder="Nhập đơn giá"
                          name={field.name}
                          value={field.value ?? ''}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value ?? '');
                          }}
                          onBlur={() => {
                            form.setFieldTouched(field.name, true);
                          }}
                          enableCheckValid={true}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
                {/* <div className="col-6 p-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildFormLabel('Số lượng vòi sạc', true)}
                    <FastField name="connectors">
                      {({ field, form, meta }) => (
                        <KTBSDropdown
                          name={field.name}
                          toggleElement={
                            <button
                              className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                              type="button"
                            >
                              {`${field.value} vòi sạc`}
                            </button>
                          }
                          selectedValue={field.value}
                          dropdownMenuItems={ChargeHelper.Data.chargePointNumberConnectorOptions}
                          dropdownMenuClassName="overflow-auto w-100"
                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          isDropdownForm={true}
                        />
                      )}
                    </FastField>
                  </div>
                </div> */}
                {/* <div className="col-6 p-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildFormLabel('Loại vòi sạc', true)}
                    <FastField name="connectorType">
                      {({ field, form, meta }) => (
                        <KTBSDropdown
                          name={field.name}
                          toggleElement={
                            <button
                              className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                              type="button"
                            >
                              {field.value ? field.value : 'Chọn loại vòi sạc'}
                            </button>
                          }
                          selectedValue={field.value}
                          dropdownMenuItems={ChargeHelper.Data.chargeConnectorTypeOptions}
                          dropdownMenuClassName="overflow-auto w-100"
                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          isDropdownForm={true}
                        />
                      )}
                    </FastField>
                  </div>
                </div> */}
                <div className="col-12 p-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildFormLabel('Mô tả')}
                    <FastField name="description">
                      {({ field, form, meta }) => (
                        <KTFormTextArea
                          placeholder="Nhập mô tả"
                          rows={3}
                          name={field.name}
                          value={field.value}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          onBlur={() => {
                            form.setFieldTouched(field.name, true);
                          }}
                          enableCheckValid={true}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Formik>

      {/* footer */}
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildGreenButton(
          !editMode ? 'Thêm' : 'Cập nhật',
          () => {
            refFormik.current.handleSubmit();
          },
          null,
          false,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogAddChargeModelView;
